"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVaccinationRecordWithTiterDto = instanceOfVaccinationRecordWithTiterDto;
exports.VaccinationRecordWithTiterDtoFromJSON = VaccinationRecordWithTiterDtoFromJSON;
exports.VaccinationRecordWithTiterDtoFromJSONTyped = VaccinationRecordWithTiterDtoFromJSONTyped;
exports.VaccinationRecordWithTiterDtoToJSON = VaccinationRecordWithTiterDtoToJSON;
exports.VaccinationRecordWithTiterDtoToJSONTyped = VaccinationRecordWithTiterDtoToJSONTyped;
const TiterInformationDto_1 = require("./TiterInformationDto");
const VaccinationDoseWithNumberDto_1 = require("./VaccinationDoseWithNumberDto");
/**
 * Check if a given object implements the VaccinationRecordWithTiterDto interface.
 */
function instanceOfVaccinationRecordWithTiterDto(value) {
    if (!('vaccinations' in value) || value['vaccinations'] === undefined)
        return false;
    if (!('titerInformation' in value) || value['titerInformation'] === undefined)
        return false;
    return true;
}
function VaccinationRecordWithTiterDtoFromJSON(json) {
    return VaccinationRecordWithTiterDtoFromJSONTyped(json, false);
}
function VaccinationRecordWithTiterDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'vaccinations': (json['vaccinations'].map(VaccinationDoseWithNumberDto_1.VaccinationDoseWithNumberDtoFromJSON)),
        'titerInformation': (0, TiterInformationDto_1.TiterInformationDtoFromJSON)(json['titerInformation']),
    };
}
function VaccinationRecordWithTiterDtoToJSON(json) {
    return VaccinationRecordWithTiterDtoToJSONTyped(json, false);
}
function VaccinationRecordWithTiterDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'vaccinations': (value['vaccinations'].map(VaccinationDoseWithNumberDto_1.VaccinationDoseWithNumberDtoToJSON)),
        'titerInformation': (0, TiterInformationDto_1.TiterInformationDtoToJSON)(value['titerInformation']),
    };
}
//# sourceMappingURL=VaccinationRecordWithTiterDto.js.map